import { FC, ReactNode, useState } from 'react';
import { DebugContext } from '../components/debug/DebugLayout';

interface DebugContextProviderProps {
  children: ReactNode;
}

export const DebugContextProvider: FC<DebugContextProviderProps> = ({ children }) => {
  const [showDebug, setShowDebug] = useState(false);
  const [isComparing, setIsComparing] = useState(false);
  
  const toggleDebug = () => setShowDebug(!showDebug);
  
  const compareScores = async () => {
    setIsComparing(true);
    // Simulate comparing scores (this would be replaced with actual logic)
    await new Promise(resolve => setTimeout(resolve, 1000));
    setIsComparing(false);
  };

  return (
    <DebugContext.Provider 
      value={{ 
        showDebug, 
        toggleDebug,
        compareScores,
        isComparing
      }}
    >
      {children}
    </DebugContext.Provider>
  );
}; 